import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PersonalizedPlan = lazyWithPreload(
  () => import('./PersonalizedPlan'),
)
